import { render, staticRenderFns } from "./PanelInvestmentData.vue?vue&type=template&id=97d895a0&scoped=true&"
import script from "./PanelInvestmentData.vue?vue&type=script&setup=true&lang=js&"
export * from "./PanelInvestmentData.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PanelInvestmentData.vue?vue&type=style&index=0&id=97d895a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d895a0",
  null
  
)

export default component.exports